export const bidiotvMoviesPt = [
  {
    "id":26,
    "contents":9,
    "name": {
      "en": "Grand Theft Auto"
    },
    "videos":[
      {
        "duration": "Watch Now",
        "id": 1100,
        "name": "Driving And Navigation",
        "preview": "https://cdn.mobiotv.com/bidiotv/GrandTheftAuto/driving-and-navigation.jpg",
        "desc": "",
        "videoUrl": "https://cdn.mobiotv.com/bidiotv/GrandTheftAuto/driving-and-navigation.mp4",
        "filename":"",
      },
      {
        "duration": "Watch Now",
        "id": 1101,
        "name": "How Missions Work",
        "preview": "https://cdn.mobiotv.com/bidiotv/GrandTheftAuto/how-missions-work.jpg",
        "desc": "",
        "videoUrl": "https://cdn.mobiotv.com/bidiotv/GrandTheftAuto/how-missions-work.mp4",
        "filename":"",
      },
      {
        "duration": "Watch Now",
        "id": 1102,
        "name": "How Open World Games Work",
        "preview": "https://cdn.mobiotv.com/bidiotv/GrandTheftAuto/how-open-world-games-work.jpg",
        "desc": "",
        "videoUrl": "https://cdn.mobiotv.com/bidiotv/GrandTheftAuto/how-open-world-games-work.mp4",
        "filename":"",
      },
      {
        "duration": "Watch Now",
        "id": 1103,
        "name": "The Open World Gameplay Loop",
        "preview": "https://cdn.mobiotv.com/bidiotv/GrandTheftAuto/the-open-world-gameplay-loop.jpg",
        "desc": "",
        "videoUrl": "https://cdn.mobiotv.com/bidiotv/GrandTheftAuto/the-open-world-gameplay-loop.mp4",
        "filename":"",
      },
      {
        "duration": "Watch Now",
        "id": 1104,
        "name": "Vice City And Leonida Setting Explained",
        "preview": "https://cdn.mobiotv.com/bidiotv/GrandTheftAuto/vice-city-and-leonida-setting-explained.jpg",
        "desc": "",
        "videoUrl": "https://cdn.mobiotv.com/bidiotv/GrandTheftAuto/vice-city-and-leonida-setting-explained.mp4",
        "filename":"",
      },
      {
        "duration": "Watch Now",
        "id": 1105,
        "name": "What Is Grand Theft Auto",
        "preview": "https://cdn.mobiotv.com/bidiotv/GrandTheftAuto/what-is-grand-theft-auto.jpg",
        "desc": "",
        "videoUrl": "https://cdn.mobiotv.com/bidiotv/GrandTheftAuto/what-is-grand-theft-auto.mp4",
        "filename":"",
      },
      {
        "duration": "Watch Now",
        "id": 1106,
        "name": "What Is Officially Confirmed",
        "preview": "https://cdn.mobiotv.com/bidiotv/GrandTheftAuto/what-is-officially-confirmed.jpg",
        "desc": "",
        "videoUrl": "https://cdn.mobiotv.com/bidiotv/GrandTheftAuto/what-is-officially-confirmed.mp4",
        "filename":"",
      },
      {
        "duration": "Watch Now",
        "id": 1107,
        "name": "Who Are Jason And Lucia",
        "preview": "https://cdn.mobiotv.com/bidiotv/GrandTheftAuto/who-are-jason-and-lucia.jpg",
        "desc": "",
        "videoUrl": "https://cdn.mobiotv.com/bidiotv/GrandTheftAuto/who-are-jason-and-lucia.mp4",
        "filename":"",
      },
      {
        "duration": "Watch Now",
        "id": 1108,
        "name": "Why A Major Gaming Event",
        "preview": "https://cdn.mobiotv.com/bidiotv/GrandTheftAuto/why-a-major-gaming-event.jpg",
        "desc": "",
        "videoUrl": "https://cdn.mobiotv.com/bidiotv/GrandTheftAuto/why-a-major-gaming-event.mp4",
        "filename":"",
      }
    ]
  },
  {
    id: 720,
    contents: 13,
    name: {
      en: "Heróis Verdes",
    },
    videos: [
      {
        duration: "Watch Now",
        id: 7200,
        name: "Heróis Verdes A mochila solar SunUp",
        preview:
          "https://cdn.mobiotv.com/pt/Her%C3%B3is+Verdes/Hero%CC%81is+Verdes+A+mochila+solar+SunUp.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobiotv.com/pt/Her%C3%B3is+Verdes/Hero%CC%81is+Verdes+A+mochila+solar+SunUp.mp4",
        fileName: "",
      },
      {
        duration: "Watch Now",
        id: 7201,
        name: "Heróis Verdes Agricultura urbana",
        preview:
          "https://cdn.mobiotv.com/pt/Her%C3%B3is+Verdes/Hero%CC%81is+Verdes+Agricultura+urbana.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobiotv.com/pt/Her%C3%B3is+Verdes/Hero%CC%81is+Verdes+Agricultura+urbana.mp4",
        fileName: "",
      },
      {
        duration: "Watch Now",
        id: 7202,
        name: "Heróis Verdes Bebendo cerveja e salvando o planeta",
        preview:
          "https://cdn.mobiotv.com/pt/Her%C3%B3is+Verdes/Hero%CC%81is+Verdes+Bebendo+cerveja+e+salvando+o+planeta.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobiotv.com/pt/Her%C3%B3is+Verdes/Hero%CC%81is+Verdes+Bebendo+cerveja+e+salvando+o+planeta.mp4",
        fileName: "",
      },
      {
        duration: "Watch Now",
        id: 7203,
        name: "Heróis Verdes Canudos amigos do meio ambiente",
        preview:
          "https://cdn.mobiotv.com/pt/Her%C3%B3is+Verdes/Hero%CC%81is+Verdes+Canudos+amigos+do+meio+ambiente.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobiotv.com/pt/Her%C3%B3is+Verdes/Hero%CC%81is+Verdes+Canudos+amigos+do+meio+ambiente.mp4",
        fileName: "",
      },
      {
        duration: "Watch Now",
        id: 7204,
        name: "Heróis Verdes Centro de resgate e reabilitação de linces",
        preview:
          "https://cdn.mobiotv.com/pt/Her%C3%B3is+Verdes/Hero%CC%81is+Verdes+Centro+de+resgate+e+reabilitac%CC%A7a%CC%83o+de+linces.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobiotv.com/pt/Her%C3%B3is+Verdes/Hero%CC%81is+Verdes+Centro+de+resgate+e+reabilitac%CC%A7a%CC%83o+de+linces.mp4",
        fileName: "",
      },
      {
        duration: "Watch Now",
        id: 7205,
        name: "Heróis Verdes Construindo uma vila sustentável",
        preview:
          "https://cdn.mobiotv.com/pt/Her%C3%B3is+Verdes/Hero%CC%81is+Verdes+Construindo+uma+vila+sustenta%CC%81vel.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobiotv.com/pt/Her%C3%B3is+Verdes/Hero%CC%81is+Verdes+Construindo+uma+vila+sustenta%CC%81vel.mp4",
        fileName: "",
      },
      {
        duration: "Watch Now",
        id: 7206,
        name: "Heróis Verdes Cultivar o seu próprio canudinho",
        preview:
          "https://cdn.mobiotv.com/pt/Her%C3%B3is+Verdes/Hero%CC%81is+Verdes+Cultivar+o+seu+pro%CC%81prio+canudinho.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobiotv.com/pt/Her%C3%B3is+Verdes/Hero%CC%81is+Verdes+Cultivar+o+seu+pro%CC%81prio+canudinho.mp4",
        fileName: "",
      },
      {
        duration: "Watch Now",
        id: 7207,
        name: "Heróis Verdes Kromkommer",
        preview:
          "https://cdn.mobiotv.com/pt/Her%C3%B3is+Verdes/Hero%CC%81is+Verdes+Kromkommer.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobiotv.com/pt/Her%C3%B3is+Verdes/Hero%CC%81is+Verdes+Kromkommer.mp4",
        fileName: "",
      },
      {
        duration: "Watch Now",
        id: 7208,
        name: 'Heróis Verdes Lutando contra os "banheiros voadores" do Quênia',
        preview:
          "https://cdn.mobiotv.com/pt/Her%C3%B3is+Verdes/Hero%CC%81is+Verdes+Lutando+contra+os+%22banheiros+voadores%22+do+Que%CC%82nia.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobiotv.com/pt/Her%C3%B3is+Verdes/Hero%CC%81is+Verdes+Lutando+contra+os+%22banheiros+voadores%22+do+Que%CC%82nia.mp4",
        fileName: "",
      },
      {
        duration: "Watch Now",
        id: 7209,
        name: "Heróis verdes O poder dos insetos",
        preview:
          "https://cdn.mobiotv.com/pt/Her%C3%B3is+Verdes/Hero%CC%81is+verdes+O+poder+dos+insetos.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobiotv.com/pt/Her%C3%B3is+Verdes/Hero%CC%81is+verdes+O+poder+dos+insetos.mp4",
        fileName: "",
      },
      {
        duration: "Watch Now",
        id: 7210,
        name: "Heróis Verdes O robô limpador das águas",
        preview:
          "https://cdn.mobiotv.com/pt/Her%C3%B3is+Verdes/Hero%CC%81is+Verdes+O+robo%CC%82+limpador+das+a%CC%81guas.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobiotv.com/pt/Her%C3%B3is+Verdes/Hero%CC%81is+Verdes+O+robo%CC%82+limpador+das+a%CC%81guas.mp4",
        fileName: "",
      },
      {
        duration: "Watch Now",
        id: 7211,
        name: "Heróis Verdes Salvar uma ave de cada vez",
        preview:
          "https://cdn.mobiotv.com/pt/Her%C3%B3is+Verdes/Hero%CC%81is+Verdes+Salvar+uma+ave+de+cada+vez.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobiotv.com/pt/Her%C3%B3is+Verdes/Hero%CC%81is+Verdes+Salvar+uma+ave+de+cada+vez.mp4",
        fileName: "",
      },
      {
        duration: "Watch Now",
        id: 7212,
        name: "Heróis Verdes Uma padaria para a crise climática",
        preview:
          "https://cdn.mobiotv.com/pt/Her%C3%B3is+Verdes/Hero%CC%81is+Verdes+Uma+padaria+para+a+crise+clima%CC%81tica.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobiotv.com/pt/Her%C3%B3is+Verdes/Hero%CC%81is+Verdes+Uma+padaria+para+a+crise+clima%CC%81tica.mp4",
        fileName: "",
      },
    ],
  },
  {
    id: 740,
    contents: 11,
    name: {
      en: "Meu Emprego dos Sonhos",
    },
    videos: [
      {
        duration: "Watch Now",
        id: 7400,
        name: "Meu emprego dos sonhos A artista de bolos",
        preview:
          "https://cdn.mobiotv.com/pt/Meu+Emprego+dos+Sonhos/Meu+emprego+dos+sonhos+A+artista+de+bolos.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobiotv.com/pt/Meu+Emprego+dos+Sonhos/Meu+emprego+dos+sonhos+A+artista+de+bolos.mp4",
        fileName: "",
      },
      {
        duration: "Watch Now",
        id: 7401,
        name: "Meu emprego dos sonhos A fotógrafa de cães",
        preview:
          "https://cdn.mobiotv.com/pt/Meu+Emprego+dos+Sonhos/Meu+emprego+dos+sonhos+A+foto%CC%81grafa+de+ca%CC%83es.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobiotv.com/pt/Meu+Emprego+dos+Sonhos/Meu+emprego+dos+sonhos+A+foto%CC%81grafa+de+ca%CC%83es.mp4",
        fileName: "",
      },
      {
        duration: "Watch Now",
        id: 7402,
        name: "Meu emprego dos sonhos A maquiadora ocupada",
        preview:
          "https://cdn.mobiotv.com/pt/Meu+Emprego+dos+Sonhos/Meu+emprego+dos+sonhos+A+maquiadora+ocupada.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobiotv.com/pt/Meu+Emprego+dos+Sonhos/Meu+emprego+dos+sonhos+A+maquiadora+ocupada.mp4",
        fileName: "",
      },
      {
        duration: "Watch Now",
        id: 7403,
        name: "Meu Emprego dos Sonhos Confeiteira de bolos 3D",
        preview:
          "https://cdn.mobiotv.com/pt/Meu+Emprego+dos+Sonhos/Meu+Emprego+dos+Sonhos+Confeiteira+de+bolos+3D.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobiotv.com/pt/Meu+Emprego+dos+Sonhos/Meu+Emprego+dos+Sonhos+Confeiteira+de+bolos+3D.mp4",
        fileName: "",
      },
      {
        duration: "Watch Now",
        id: 7404,
        name: "Meu emprego dos sonhos Criando bonecos gigantes",
        preview:
          "https://cdn.mobiotv.com/pt/Meu+Emprego+dos+Sonhos/Meu+emprego+dos+sonhos+Criando+bonecos+gigantes.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobiotv.com/pt/Meu+Emprego+dos+Sonhos/Meu+emprego+dos+sonhos+Criando+bonecos+gigantes.mp4",
        fileName: "",
      },
      {
        duration: "Watch Now",
        id: 7405,
        name: "Meu Emprego dos Sonhos Cuidadora de animais selvagens",
        preview:
          "https://cdn.mobiotv.com/pt/Meu+Emprego+dos+Sonhos/Meu+Emprego+dos+Sonhos+Cuidadora+de+animais+selvagens.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobiotv.com/pt/Meu+Emprego+dos+Sonhos/Meu+Emprego+dos+Sonhos+Cuidadora+de+animais+selvagens.mp4",
        fileName: "",
      },
      {
        duration: "Watch Now",
        id: 7406,
        name: "Meu emprego dos sonhos Fazendo arte com bolhas",
        preview:
          "https://cdn.mobiotv.com/pt/Meu+Emprego+dos+Sonhos/Meu+emprego+dos+sonhos+Fazendo+arte+com+bolhas.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobiotv.com/pt/Meu+Emprego+dos+Sonhos/Meu+emprego+dos+sonhos+Fazendo+arte+com+bolhas.mp4",
        fileName: "",
      },
      {
        duration: "Watch Now",
        id: 7407,
        name: "Meu emprego dos sonhos Fotógrafa de bonecas",
        preview:
          "https://cdn.mobiotv.com/pt/Meu+Emprego+dos+Sonhos/Meu+emprego+dos+sonhos+Foto%CC%81grafa+de+bonecas.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobiotv.com/pt/Meu+Emprego+dos+Sonhos/Meu+emprego+dos+sonhos+Foto%CC%81grafa+de+bonecas.mp4",
        fileName: "",
      },
      {
        duration: "Watch Now",
        id: 7408,
        name: "Meu Emprego dos Sonhos O Guardião dos Répteis",
        preview:
          "https://cdn.mobiotv.com/pt/Meu+Emprego+dos+Sonhos/Meu+Emprego+dos+Sonhos+O+Guardia%CC%83o+dos+Re%CC%81pteis.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobiotv.com/pt/Meu+Emprego+dos+Sonhos/Meu+Emprego+dos+Sonhos+O+Guardia%CC%83o+dos+Re%CC%81pteis.mp4",
        fileName: "",
      },
      {
        duration: "Watch Now",
        id: 7409,
        name: "Meu emprego dos sonhos O guia de vida selvagem",
        preview:
          "https://cdn.mobiotv.com/pt/Meu+Emprego+dos+Sonhos/Meu+emprego+dos+sonhos+O+guia+de+vida+selvagem.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobiotv.com/pt/Meu+Emprego+dos+Sonhos/Meu+emprego+dos+sonhos+O+guia+de+vida+selvagem.mp4",
        fileName: "",
      },
      {
        duration: "Watch Now",
        id: 7410,
        name: "Meu emprego dos sonhos O mundo da espeleologia",
        preview:
          "https://cdn.mobiotv.com/pt/Meu+Emprego+dos+Sonhos/Meu+emprego+dos+sonhos+O+mundo+da+espeleologia.jpeg",
        desc: "",
        videoUrl:
          "https://cdn.mobiotv.com/pt/Meu+Emprego+dos+Sonhos/Meu+emprego+dos+sonhos+O+mundo+da+espeleologia.mp4",
        fileName: "",
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/constants/bidiotvmovies_pt.js